// LIST
export const FETCH_SURVEYS = "app/Survey/FETCH_SURVEYS";
export const FETCH_SURVEYS_SUCCESS = "app/Survey/FETCH_SURVEYS_SUCCESS";
export const FETCH_SURVEYS_FAILURE = "app/Survey/FETCH_SURVEYS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Survey/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Survey/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Survey/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_SURVEY = "app/Survey/ADD_SURVEY";
export const ADD_SURVEY_SUCCESS = "app/Survey/ADD_SURVEY_SUCCESS";
export const ADD_SURVEY_FAILURE = "app/Survey/ADD_SURVEY_FAILURE";

// EDIT
export const EDIT_SURVEY = "app/Survey/EDIT_SURVEY";
export const EDIT_SURVEY_SUCCESS = "app/Survey/EDIT_SURVEY_SUCCESS";
export const EDIT_SURVEY_FAILURE = "app/Survey/EDIT_SURVEY_FAILURE";

// DELETE
export const DELETE_SURVEY = "app/Survey/DELETE_SURVEY";
export const DELETE_SURVEY_SUCCESS = "app/Survey/DELETE_SURVEY_SUCCESS";
export const DELETE_SURVEY_FAILURE = "app/Survey/DELETE_SURVEY_FAILURE";

export const TOGGLE_INVITE_MODAL = "app/Survey/TOGGLE_INVITE_MODAL";
export const TOGGLE_QUE_MODAL = "app/Survey/TOGGLE_QUE_MODAL";
export const TOGGLE_DELETE = "app/Survey/TOGGLE_DELETE";
export const TOGGLE_INVEMP_MODAL = "app/Survey/TOGGLE_INVEMP_MODAL";

export const SET_YEAR = "app/Survey/SET_YEAR";
export const SET_DASH_YEAR = "app/Survey/SET_DASH_YEAR";

export const INVITE = "app/Survey/INVITE";
export const INVITE_SUCCESS = "app/Survey/INVITE_SUCCESS";
export const INVITE_FAILURE = "app/Survey/INVITE_FAILURE";

export const GENERATE_QR = "app/Survey/GENERATE_QR";
export const GENERATE_QR_SUCCESS = "app/Survey/GENERATE_QR_SUCCESS";
export const GENERATE_QR_FAILURE = "app/Survey/GENERATE_QR_FAILURE";

export const FETCH_INVITEES = "app/Survey/FETCH_INVITEES";
export const FETCH_INVITEES_SUCCESS = "app/Survey/FETCH_INVITEES_SUCCESS";
export const FETCH_INVITEES_FAILURE = "app/Survey/FETCH_INVITEES_FAILURE";

export const FETCH_RESPONSES = "app/Survey/FETCH_RESPONSES";
export const FETCH_RESPONSES_SUCCESS = "app/Survey/FETCH_RESPONSES_SUCCESS";
export const FETCH_RESPONSES_FAILURE = "app/Survey/FETCH_RESPONSES_FAILURE";

export const GET_RESPONSE = "app/Survey/GET_RESPONSE";
export const GET_RESPONSE_SUCCESS = "app/Survey/GET_RESPONSE_SUCCESS";
export const GET_RESPONSE_FAILURE = "app/Survey/GET_RESPONSE_FAILURE";

export const GET_DASHBOAD = "app/Survey/GET_DASHBOAD";
export const GET_DASHBOAD_SUCCESS = "app/Survey/GET_DASHBOAD_SUCCESS";
export const GET_DASHBOAD_FAILURE = "app/Survey/GET_DASHBOAD_FAILURE";

export const GET_OVERVIEW = "app/Survey/GET_OVERVIEW";
export const GET_OVERVIEW_SUCCESS = "app/Survey/GET_OVERVIEW_SUCCESS";
export const GET_OVERVIEW_FAILURE = "app/Survey/GET_OVERVIEW_FAILURE";

export const GET_HEADLINES = "app/Survey/GET_HEADLINES";
export const GET_HEADLINES_SUCCESS = "app/Survey/GET_HEADLINES_SUCCESS";
export const GET_HEADLINES_FAILURE = "app/Survey/GET_HEADLINES_FAILURE";

export const GET_JSON = "app/Survey/GET_JSON";
export const GET_JSON_SUCCESS = "app/Survey/GET_JSON_SUCCESS";
export const GET_JSON_FAILURE = "app/Survey/GET_JSON_FAILURE";
export const UPDATE_JSON = "app/Survey/UPDATE_JSON";

export const SEARCH_SURVEY = "app/Survey/SEARCH_SURVEY";
export const SEARCH_SURVEY_SUCCESS = "app/Survey/SEARCH_SURVEY_SUCCESS";
export const SEARCH_SURVEY_FAILURE = "app/Survey/SEARCH_SURVEY_FAILURE";

export const GET_ACTIONS = "app/Survey/GET_ACTIONS";
export const GET_ACTIONS_SUCCESS = "app/Survey/GET_ACTIONS_SUCCESS";
export const GET_ACTIONS_FAILURE = "app/Survey/GET_ACTIONS_FAILURE";

export const TOGGLE_ACTION_MODAL = "app/Survey/TOGGLE_ACTION_MODAL";
export const TOGGLE_ITEM_MODAL = "app/Survey/TOGGLE_ITEM_MODAL";
export const TOGGLE_OUTCOME_MODAL = "app/Survey/TOGGLE_OUTCOME_MODAL";
export const TOGGLE_COMMENT = "app/Survey/TOGGLE_COMMENT";
export const TOGGLE_FINDING_COMMENT = "app/Survey/TOGGLE_FINDING_COMMENT";

export const ADD_ACTION = "app/Survey/ADD_ACTION";
export const ADD_ACTION_SUCCESS = "app/Survey/ADD_ACTION_SUCCESS";
export const ADD_ACTION_FAILURE = "app/Survey/ADD_ACTION_FAILURE";

export const EDIT_ACTION = "app/Survey/EDIT_ACTION";
export const EDIT_ACTION_SUCCESS = "app/Survey/EDIT_ACTION_SUCCESS";
export const EDIT_ACTION_FAILURE = "app/Survey/EDIT_ACTION_FAILURE";

export const DELETE_ACTION = "app/Survey/DELETE_ACTION";
export const DELETE_ACTION_SUCCESS = "app/Survey/DELETE_ACTION_SUCCESS";
export const DELETE_ACTION_FAILURE = "app/Survey/DELETE_ACTION_FAILURE";

export const ADD_ITEM = "app/Survey/ADD_ITEM";
export const ADD_ITEM_SUCCESS = "app/Survey/ADD_ITEM_SUCCESS";
export const ADD_ITEM_FAILURE = "app/Survey/ADD_ITEM_FAILURE";

export const EDIT_ITEM = "app/Survey/EDIT_ITEM";
export const EDIT_ITEM_SUCCESS = "app/Survey/EDIT_ITEM_SUCCESS";
export const EDIT_ITEM_FAILURE = "app/Survey/EDIT_ITEM_FAILURE";

export const ADD_OUTCOME = "app/Survey/ADD_OUTCOME";
export const ADD_OUTCOME_SUCCESS = "app/Survey/ADD_OUTCOME_SUCCESS";
export const ADD_OUTCOME_FAILURE = "app/Survey/ADD_OUTCOME_FAILURE";

export const EDIT_OUTCOME = "app/Survey/EDIT_OUTCOME";
export const EDIT_OUTCOME_SUCCESS = "app/Survey/EDIT_OUTCOME_SUCCESS";
export const EDIT_OUTCOME_FAILURE = "app/Survey/EDIT_OUTCOME_FAILURE";

export const GET_PLAN = "app/Survey/GET_PLAN";
export const GET_PLAN_SUCCESS = "app/Survey/GET_PLAN_SUCCESS";
export const GET_PLAN_FAILURE = "app/Survey/GET_PLAN_FAILURE";

export const DELETE_PLAN = "app/Survey/DELETE_PLAN";
export const DELETE_PLAN_SUCCESS = "app/Survey/DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_FAILURE = "app/Survey/DELETE_PLAN_FAILURE";

export const PRINT_PLAN = "app/Survey/PRINT_PLAN";
export const PRINT_PLAN_SUCCESS = "app/Survey/PRINT_PLAN_SUCCESS";
export const PRINT_PLAN_FAILURE = "app/Survey/PRINT_PLAN_FAILURE";

export const EXPORT_SURVEY = "app/Survey/EXPORT_SURVEY";
export const EXPORT_SURVEY_SUCCESS = "app/Survey/EXPORT_SURVEY_SUCCESS";
export const EXPORT_SURVEY_FAILURE = "app/Survey/EXPORT_SURVEY_FAILURE";

export const GET_FINDING_REPORT = "app/Survey/GET_FINDING_REPORT";
export const GET_FINDING_REPORT_SUCCESS =
  "app/Survey/GET_FINDING_REPORT_SUCCESS";
export const GET_FINDING_REPORT_FAILURE =
  "app/Survey/GET_FINDING_REPORT_FAILURE";

export const FETCH_TEMPLATES = "app/Survey/FETCH_TEMPLATES";
export const FETCH_TEMPLATES_SUCCESS = "app/Survey/FETCH_TEMPLATES_SUCCESS";
export const FETCH_TEMPLATES_FAILURE = "app/Survey/FETCH_TEMPLATES_FAILURE";

export const FETCH_ANALYTICS = "app/Survey/FETCH_ANALYTICS";
export const FETCH_ANALYTICS_SUCCESS = "app/Survey/FETCH_ANALYTICS_SUCCESS";
export const FETCH_ANALYTICS_FAILURE = "app/Survey/FETCH_ANALYTICS_FAILURE";

export const UPDATE_SUMMARY = "app/Survey/UPDATE_SUMMARY";
export const UPDATE_SUMMARY_SUCCESS = "app/Survey/UPDATE_SUMMARY_SUCCESS";
export const UPDATE_SUMMARY_FAILURE = "app/Survey/UPDATE_SUMMARY_FAILURE";

export const UPDATE_SURVEY_ADD = "app/Survey/UPDATE_SURVEY_ADD";

export const TOGGLE_COPY_MODAL = "app/Survey/TOGGLE_COPY_MODAL";
export const TOGGLE_BROWSE_MODAL = "app/Survey/TOGGLE_BROWSE_MODAL";
export const TOGGLE_AI_MODAL = "app/Survey/TOGGLE_AI_MODAL";

export const GENERATE_JSON = "app/Survey/GENERATE_JSON";
export const GENERATE_JSON_SUCCESS = "app/Survey/GENERATE_JSON_SUCCESS";
export const GENERATE_JSON_FAILURE = "app/Survey/GENERATE_JSON_FAILURE";

export const GET_TEMPLATES = "app/Survey/GET_TEMPLATES";
export const GET_TEMPLATES_SUCCESS = "app/Survey/GET_TEMPLATES_SUCCESS";
export const GET_TEMPLATES_FAILURE = "app/Survey/GET_TEMPLATES_FAILURE";

export const GET_PREDICTION_REPORT = "app/Survey/GET_PREDICTION_REPORT";
export const GET_PREDICTION_REPORT_SUCCESS =
  "app/Survey/GET_PREDICTION_REPORT_SUCCESS";
export const GET_PREDICTION_REPORT_FAILURE =
  "app/Survey/GET_PREDICTION_REPORT_FAILURE";

export const GET_AI_REPORT = "app/Survey/GET_AI_REPORT";
export const GET_AI_REPORT_SUCCESS = "app/Survey/GET_AI_REPORT_SUCCESS";
export const GET_AI_REPORT_FAILURE = "app/Survey/GET_AI_REPORT_FAILURE";
